module.exports = __webpack_public_path__ + "img/avatar6.f4239bd6.png";